document.addEventListener('DOMContentLoaded', function() {
    const hiddenFilters = [
        "Ecolab", "Ecolab Afwasmiddel", "Ecolab Naglansmiddel", "Ecolab Schoonmaakmiddel",
        "Ecolab Vaatwasmiddel", "Ecolab Wasmiddel", "Ecopuur", "Ecopuur Handdoekpapier",
        "Ecopuur Handdoekrollen", "Ecopuur Poetsrollen", "Ecopuur Toiletpapier",
        "Ecopuur Zeep", "Euro Products", "Numatic", "Numatic Accessoires",
        "Numatic Mopsystemen", "Numatic Schrobzuigmachines", "Numatic Stofzuigers",
        "Numatic Waterzuigers", "Numatic Werkwagens", "Suma", "Suma Desinfectie",
        "Suma Naglansmiddel", "Suma Ontvettingsmiddel", "Suma Schoonmaakmiddel",
        "Suma Vaatwasmiddel", "Tana Allesreiniger", "Tana Glasreiniger",
        "Tana Kauwgomverwijderaar", "Tana Keuken- en Vaatreiniger", "Tana Ontkalker",
        "Tana Parfumreiniger", "Tana Professional", "Tana Sanitairreiniger",
        "Tana Toiletreiniger", "Tana Vloerreiniger", "Tana Wastabletten", "Taski",
        "Taski Interieurverzorging", "Taski Machines", "Taski Sanitairverzorging",
        "Taski SmartDoseo", "Taski Vloerverzorging", "Tork", "Tork Afval- en Hygiënebakken",
        "Tork Desinfectie", "Tork Dispensers", "Tork Handdoekpapier", "Tork Handdoekrollen",
        "Tork Industrierollen", "Tork Keukenpapier", "Tork Luchtverfrissers",
        "Tork Poetsrollen", "Tork Servetten en Tissues", "Tork Toiletpapier",
        "Tork Zeep", "Vileda", "Vileda Accessoires", "Vileda Mopsystemen",
        "Vileda Werkwagens"
    ];

    function removeElements() {
        const details = document.querySelectorAll('details.accordion');
        
        details.forEach(detail => {
            const toggle = detail.querySelector('.accordion__toggle');
            if (toggle && toggle.textContent.trim().includes('Categorieën')) {
                const checkboxContainers = detail.querySelectorAll('.checkbox-container');
                
                checkboxContainers.forEach(container => {
                    const label = container.querySelector('label');
                    if (label) {
                        const labelText = label.textContent.trim();
                        if (hiddenFilters.some(filter => 
                            labelText.toLowerCase().includes(filter.toLowerCase()))) {
                            container.remove(); // Actually remove the element instead of hiding
                        }
                    }
                });
            }
        });
    }

    // Initial removal
    removeElements();

    // Create a MutationObserver instance
    const observer = new MutationObserver((mutations) => {
        removeElements();
    });

    // Options for the observer (which mutations to observe)
    const config = {
        childList: true,
        subtree: true,
        attributes: true
    };

    // Watch the entire facet form
    const form = document.querySelector('form[is="facet-form"]');
    if (form) {
        observer.observe(form, config);
    }

    // Additional event handlers
    const events = ['click', 'change', 'input'];
    events.forEach(eventType => {
        document.addEventListener(eventType, () => {
            setTimeout(removeElements, 0);
            setTimeout(removeElements, 50);
            setTimeout(removeElements, 100);
        }, true);
    });

    // Handle URL changes
    let lastUrl = location.href;
    new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            setTimeout(removeElements, 0);
            setTimeout(removeElements, 50);
            setTimeout(removeElements, 100);
        }
    }).observe(document, {subtree: true, childList: true});

    // Handle Shopify specific events
    const shopifyEvents = [
        'shopify:section:load',
        'shopify:section:unload',
        'shopify:section:select',
        'shopify:section:deselect',
        'shopify:block:select',
        'shopify:block:deselect'
    ];

    shopifyEvents.forEach(event => {
        document.addEventListener(event, () => {
            setTimeout(removeElements, 0);
            setTimeout(removeElements, 50);
            setTimeout(removeElements, 100);
        });
    });
});